import * as React from "react";
import ButtonGrid from "@tunnel-components/@sharded/widgets/forms/input/button/custom/component";
import * as StyledComponent from "@tunnel-components/@sharded/@styled/styled";
import Icons from "@tunnel-components/@sharded/@widgets/icons/component";
import { Link } from "react-router-dom";
import Particles from "@tunnel-components/@sharded/widgets/particules/component";
import * as Paths from "@tunnel-enums/index";
import SnackBar from "@tunnel-components/@sharded/@widgets/snack-bar/succees/component";
import HealthCheck from "@tunnel-components/@sharded/healthCheck";
import * as i18next from "i18next"; // traduction

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */

  const {
    onChangeValue,
    onSubmitValues,
    submitSend,
    warning,
    passwordType,
    onChangePasswordType,
    error,
    success,
    formatLogin,
    tokenexpired,
  } = props;
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name react-router-dom
   * @infos "https://reactjs.org"
   */

  const CFG_NAMESPACE = "check";
  const LDAP_NAMESPACE = "env";
  return (
    <div className="authentification-overlay ">
      {window[CFG_NAMESPACE].enabled && (
        <HealthCheck
          delay={window[CFG_NAMESPACE].CHECK_DELAY}
          timeout={window[CFG_NAMESPACE].CHECK_TIMEOUT}
        />
      )}
      <Particles>
        <div className="authentification">
          <form className="authente-box " onSubmit={onSubmitValues}>
            <div className="logo-apps">
              <div className="logo-user" />
            </div>
            <div className="login-infos">
              <div className="box-form ">
                <StyledComponent.Container>
                  <StyledComponent.ContainerInput
                    error={warning || error || formatLogin || tokenexpired}
                    style={{ borderRadius: "5px" }}
                  >
                    <StyledComponent.Input
                      style={{ paddingRight: "45px", boxSizing: "border-box" }}
                      type="text"
                      name="identifiant"
                      // value={identifiant}
                      placeholder={i18next.t("saisisser l'identifiant")}
                      autoComplete="off"
                      onChange={onChangeValue}
                    />
                    <StyledComponent.Icon
                      style={{ width: "18px", cursor: "default" }}
                    >
                      <Icons user={true} color="#b6b3b3" />
                    </StyledComponent.Icon>
                  </StyledComponent.ContainerInput>
                </StyledComponent.Container>
              </div>
              <div className="box-form ">
                <StyledComponent.Container>
                  <StyledComponent.ContainerInput
                    error={warning || error || formatLogin || tokenexpired}
                    style={{ borderRadius: "5px" }}
                  >
                    <StyledComponent.Input
                      style={{ paddingRight: "45px", boxSizing: "border-box" }}
                      type={passwordType ? "password" : "text"}
                      name="password"
                      // value={password}
                      placeholder={i18next.t("saisisser le mot de passe")}
                      autoComplete="off"
                      onChange={onChangeValue}
                    />
                    <StyledComponent.Icon
                      style={{ width: "22px" }}
                      onClick={onChangePasswordType}
                    >
                      <Icons keyuser={true} color="#b6b3b3" />
                    </StyledComponent.Icon>
                  </StyledComponent.ContainerInput>
                </StyledComponent.Container>
              </div>
              <StyledComponent.BoxForms isVisible={!submitSend}>
                {!window[LDAP_NAMESPACE].LDAP_AUTH && <div className="box-form ">
                  <p className="forget-pwd ">
                    {" "}
                    <Link to={Paths.PathsNamesEnums.FOGETPASSWORD}>
                      {i18next.t("mot de passe oublier")} ?
                    </Link>
                  </p>
                </div>}
                <div className="box-form-btn">
                  <div
                    style={{ position: "absolute", width: "auto", right: "0" }}
                  >
                    <ButtonGrid
                      onSubmit={!success ? onSubmitValues : undefined}
                      text={i18next.t("se connecter")}
                    />
                  </div>
                </div>
              </StyledComponent.BoxForms>
              <StyledComponent.BoxForms isVisible={submitSend}>
                <div className="actionLoader" style={{ marginTop: "10px" }}>
                  <div className="lds-spinner">
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                  </div>
                </div>
              </StyledComponent.BoxForms>
            </div>
          </form>
        </div>

        <SnackBar
          style={{
            backgroundColor: "#00E1B3",
            left: "50%",
            right: "unset",
            transform: "translate(-50%,0)",
          }}
          isVisible={success && !warning && !error && !formatLogin}
          someTextSuccees={i18next.t("authentification est reussie")}
        />
        <SnackBar
          style={{
            backgroundColor: "#ED5B56",
            left: "50%",
            right: "unset",
            transform: "translate(-50%,0)",
          }}
          isVisible={formatLogin}
          someTextSuccees={i18next.t("syntaxe du champ est  invalide")}
        />
        <SnackBar
          style={{
            backgroundColor: "#ED5B56",
            left: "50%",
            right: "unset",
            transform: "translate(-50%,0)",
          }}
          isVisible={warning && !error}
          someTextSuccees={i18next.t("les champs obligatoires")}
        />
        <SnackBar
          style={{
            backgroundColor: "#ED5B56",
            left: "50%",
            right: "unset",
            transform: "translate(-50%,0)",
          }}
          isVisible={error}
          someTextSuccees={i18next.t("les informations sont incorrectes")}
        />
        <SnackBar
          style={{
            backgroundColor: "#ED5B56",
            left: "50%",
            right: "unset",
            transform: "translate(-50%,0)",
          }}
          isVisible={tokenexpired}
          someTextSuccees={i18next.t("le token n'est plus valide")}
        />
      </Particles>
    </div>
  );
};
/** Valeurs par défaut des props */
Component.defaultProps = {
  error: false,
  warning: false,
  tokenexpired: false,
  submitSend: true,
};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  onChangeValue?: React.EventHandler<React.ChangeEvent<HTMLInputElement>>;
  onSubmitValues?: React.EventHandler<any>;
  loading?: any;
  warning?: any;
  error?: boolean;
  success?: boolean;
  tokenexpired?: boolean;
  tunnelWatchInfos?: boolean;
  formatLogin?: boolean;
  identifiant?: any;
  password?: any;
  passwordType?: boolean;
  onChangePasswordType?: any;
  submitSend?: boolean;
}
/** @export HOC pure */
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/login/component.tsx